import React from 'react';

import { LomavisPlatformIcon } from '../LomavisPlatformIcon';
import { Spinner } from 'react-bootstrap';

interface LomavisCompetitorIconProps {
  /** The text to display inside the H1 heading */
  image: string;
  platform: string;
  onClick: () => void;
  isRemoving?: boolean;
}

/**
 * Atoms: LomavisCompetitorIcon
 */
export const LomavisCompetitorIcon: React.FC<LomavisCompetitorIconProps> = ({
  image,
  platform,
  onClick,
  isRemoving
}) => {
  return (
    <div className="position-relative h-40px w-40px">
      <img
        className="h-40px w-40px rounded-circle"
        src={image}
        alt=""
        aria-label="Competitor avatar"
      />

      <span
        onClick={onClick}
        className="rounded-circle border h-20px w-20px bg-white position-absolute top-0 start-100 translate-middle d-flex justify-content-center align-items-center cursor-pointer"
      >
        {isRemoving ? (
          <Spinner animation="border" size="sm" />
        ) : (
          <i className="fa-regular fa-xmark fs-3"></i>
        )}
      </span>

      <span className="rounded-circle border border-white bg-white position-absolute bottom-0 start-100 translate-middle-x d-flex justify-content-center align-items-center">
        <LomavisPlatformIcon key={platform} platform={platform} />
      </span>
    </div>
  );
};
